var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"my-2",attrs:{"color":"primary","rounded":"","depressed":"","small":"","loading":_vm.loading,"disabled":_vm.loading},on:{"click":_vm.downloadZipFile}},[_c('b',[_vm._v(_vm._s("Download cover photos as ZIP"))])])}
var staticRenderFns = []

export { render, staticRenderFns }